import { AlertTriangle } from "lucide-react";

export const OTP_DELIVERY_NOTICE = {
  lead: "Can't see the email?",
  body: "It comes from Pedagogue <hello@pedagogue.io>. Check your junk or spam folder — and if your school uses an email security service (for example Mimecast), check its quarantine or \"held mail\" digest. Adding hello@pedagogue.io to your safe senders stops this happening next time.",
};

export const OtpDeliveryNotice: React.FC = () => (
  <div
    role="status"
    data-testid="otp-delivery-notice"
    className="rounded-lg border border-pd-line bg-pd-surface px-4 py-3 text-small text-pd-ink"
  >
    <div className="flex gap-2">
      <AlertTriangle aria-hidden="true" className="mt-0.5 shrink-0" size={18} />
      <p>
        <strong>{OTP_DELIVERY_NOTICE.lead}</strong> {OTP_DELIVERY_NOTICE.body}
      </p>
    </div>
  </div>
);
